import axios from "axios";
import Config from "src/config";

const v2_actionChatInternoEnviarMsg = (id, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chat-internal/${id}/enviar-mensagem`,
        data
    });
};
export default v2_actionChatInternoEnviarMsg;
